  // updated manually apr 29, 2024

export default {
  au: {
    market1oz: 2336.50,
    discount: 0.01
  },
  ag: {
    market1oz: 27.143,
    discount: 0.10
  },
}